import { render, staticRenderFns } from "./corneaOrder.vue?vue&type=template&id=c024ba4e&scoped=true&"
import script from "./corneaOrder.vue?vue&type=script&lang=js&"
export * from "./corneaOrder.vue?vue&type=script&lang=js&"
import style0 from "./corneaOrder.vue?vue&type=style&index=0&id=c024ba4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c024ba4e",
  null
  
)

export default component.exports